import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Box,
  Paper,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  IconButton,
  Card,
  CardContent,
  Grid,
  TextField,
  Chip,
  Checkbox,
  ListItemText,
  Tabs,
  Tab,
  CircularProgress,
  Snackbar,
  Alert,
  InputAdornment,
} from "@mui/material";
import { ChevronLeft, ChevronRight, Close } from "@mui/icons-material";
import config from "../../config.js";
import dashboardJson from "../../data/dashboard/dashboard.json";
import axios from "axios";
import { reportsApi } from "../manageData/reportsApi.js";
import { useNavigate } from "react-router";
import ReplayMap from "./ReplayMap.jsx";
import dayjs from "dayjs";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  getUserDateFormat,
  getUserTimeFormat,
} from "../../utils/formatDate.js";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DateRangePickerField from "../helper/DateRangePickerField.jsx";
import SubTitle from "../common/SubTitle.jsx";
import TitleBar from "../navbar/TitleBar.jsx";
import NavMenu from "../navbar/NavMenu.jsx";
import replayJson from "../../data/replay/replay.json";
import Footer from "../common/Footer.jsx";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { convertToDateFnsFormat } from "../../utils/formatDate.js";
import NormalArrowFunction from "../common/NormalArrowFunction.jsx";

const orgId = "168";

const getIsDemo = () => {
  return false;
};

const getNormalizedValue = (value) => {
  if (value === "" || value === null || value === undefined) {
    return "";
  }

  return String(value);
};

const getVehicleDeviceId = (vehicle) =>
  getNormalizedValue(vehicle?.device_id ?? vehicle?.deviceId);

const getVehicleRecordId = (vehicle) =>
  getNormalizedValue(vehicle?.id ?? vehicle?.vehicleId);

const getUniqueValues = (values = []) => {
  return [...new Set((values || []).filter((value) => value !== "" && value !== null && value !== undefined))];
};

const getUniqueVehiclesByDeviceId = (vehicles = []) => {
  const seen = new Set();

  return (vehicles || []).filter((vehicle) => {
    const deviceId = getVehicleDeviceId(vehicle);

    if (!deviceId || seen.has(deviceId)) {
      return false;
    }

    seen.add(deviceId);
    return true;
  });
};

const getUniqueStopsById = (stops = []) => {
  const seen = new Set();

  return (stops || []).filter((stop) => {
    const stopId =
      stop?.id !== undefined && stop?.id !== null
        ? String(stop.id)
        : `${stop?.latitude ?? ""}-${stop?.longitude ?? ""}-${stop?.name ?? ""}`;

    if (!stopId || seen.has(stopId)) {
      return false;
    }

    seen.add(stopId);
    return true;
  });
};

const ReplayVehicle = () => {
  const navigate = useNavigate();
  const [selectedVehicle, setSelectedVehicle] = useState({
    previousTab: "",
    vehicleId: "",
  });
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [routeList, setRouteList] = useState([]);
  // const [selectedRoute, setSelectedRoute] = useState("");
  const [selectedRoute, setSelectedRoute] = useState([]);
  const [vehicleLoading, setVehicleLoading] = useState(true);
  const [selectedTrip, setSelectedTrip] = useState("");
  const [currentPositionIndex, setCurrentPositionIndex] = useState(0);
  const [tripPath, setTripPath] = useState([]);
  const [currentPosition, setCurrentPosition] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [routeData, setRouteData] = useState([]);
  const [location, setLocation] = useState([]);
  // State variables
  const [selectedDateRange, setSelectedDateRange] = useState("today");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [directions, setDirections] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);

  const [loading, setLoading] = useState(false);
  const [loadingTrip, setLoadingTrip] = useState(false);
  const [locationLoader, setLocationLoader] = useState(false);

  const playbackIntervalRef = useRef(null);
  const [selectedSite, setSelectedSite] = useState("");
  const [sitesLoading, setSitesLoading] = useState(false);
  const [sitesList, setSitesList] = useState([]);
  const [errorMessage, setErrorMessage] = useState({
    vehicleSelected: null,
    tripSelected: null,
    tripList: null,
    siteSelected: null,
    siteList: null,
    routesSelected: null,
    routesList: null,
    startTime: null,
    endTime: null,
    startDate: null,
    endDate: null,
    duration: null,
  });

  const [selectedTab, setSelectedTab] = useState(0);
  const [timeRange, setTimeRange] = useState({
    start: new Date(new Date().setHours(0, 0, 0, 0)), // 12:00 AM (Date)
    end: new Date(new Date().setHours(12, 0, 0, 0)), // 12:00 PM (Date)
  });
  const [customDateTimes, setCustomDateTimes] = useState({});

  const [leftOpen, setLeftOpen] = useState(true);
  const [leftHeight, setLeftHeight] = useState("auto");
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const allVehiclesRef = useRef([]);
  const uniqueVehicleList = getUniqueVehiclesByDeviceId(vehicleList);
  const dateFormat = getUserDateFormat() || "MM/DD/YYYY";
  // Examples:
  // "YYYY/MM/DD"
  // "DD/MM/YYYY"
  // "MM/DD/YYYY"
  // "DD MMM YYYY"
  const startInputRef = useRef();
  const endInputRef = useRef();

  const handleOpenStartPicker = (e) => {
    e.stopPropagation();
    if (startInputRef.current) {
      startInputRef.current.showPicker?.(); // call only if supported
    }
  };

  const handleOpenEndPicker = (e) => {
    e.stopPropagation();
    if (endInputRef.current) {
      endInputRef.current.showPicker?.(); // call only if supported
    }
  };

  const resolveVehiclesFromSource = useCallback((vehicleReferences = []) => {
    const canonicalVehicles = Array.isArray(allVehiclesRef.current)
      ? allVehiclesRef.current
      : [];

    if (!canonicalVehicles.length) {
      return getUniqueVehiclesByDeviceId(vehicleReferences);
    }

    const vehiclesById = new Map();
    const vehiclesByDeviceId = new Map();

    canonicalVehicles.forEach((vehicle) => {
      const recordId = getVehicleRecordId(vehicle);
      const deviceId = getVehicleDeviceId(vehicle);

      if (recordId && !vehiclesById.has(recordId)) {
        vehiclesById.set(recordId, vehicle);
      }

      if (deviceId && !vehiclesByDeviceId.has(deviceId)) {
        vehiclesByDeviceId.set(deviceId, vehicle);
      }
    });

    const resolvedVehicles = (vehicleReferences || [])
      .map((vehicleReference) => {
        if (!vehicleReference) {
          return null;
        }

        if (typeof vehicleReference !== "object") {
          const lookupKey = getNormalizedValue(vehicleReference);
          return (
            vehiclesById.get(lookupKey) ||
            vehiclesByDeviceId.get(lookupKey) ||
            null
          );
        }

        const recordId = getVehicleRecordId(vehicleReference);
        const deviceId = getVehicleDeviceId(vehicleReference);
        const matchedVehicle =
          (recordId ? vehiclesById.get(recordId) : null) ||
          (deviceId ? vehiclesByDeviceId.get(deviceId) : null);

        if (matchedVehicle) {
          return {
            ...vehicleReference,
            ...matchedVehicle,
          };
        }

        return deviceId ? vehicleReference : null;
      })
      .filter(Boolean);

    return getUniqueVehiclesByDeviceId(resolvedVehicles);
  }, []);

  // Equal height sync effect
  useEffect(() => {
    if (leftRef.current && rightRef.current) {
      const maxHeight = Math.max(
        leftRef.current.scrollHeight,
        rightRef.current.scrollHeight
      );
      setLeftHeight(maxHeight);
    }
  }, [leftOpen]);

  const getRoutesUnderSites = (id) => {
    if (getIsDemo()) {
      const sites = replayJson?.replay?.[
        "site/organization/route?organizationId=${organizationId}&siteId=${id}"
      ]?.filter((siteId) => siteId?.id === parseInt(id));
      setRouteList(sites);
      return;
    }
    try {
      const orgId = JSON.parse(localStorage.getItem("userState"))?.organization
        ?.id;
      const organizationId = orgId;
      axios
        .get(
          `${config.baseURL}/site/organization/route?organizationId=${organizationId}&siteId=${id}`,
          { withCredentials: true }
        )
        .then((response) => {
          let sites = [];
          if (Array.isArray(response.data)) {
            sites = response.data;
          } else if (Array.isArray(response.data)) {
            sites = response.data;
          }
          // console.log(sites);
          setRouteList(sites);
        })
        .catch((error) => {
          setRouteList([]);
          if (error.response && error.response.status === 401) {
            navigate("/");
          }
        });
    } catch (e) {
      console.log(e);
    }
  };
  const getSites = async () => {
    try {
      setSitesLoading(true);
      let sites = [];
      if (getIsDemo()) {
        sites = replayJson?.replay?.["site/organization?organizationId=168"];
      } else {
        const orgId = JSON.parse(localStorage.getItem("userState"))
          ?.organization?.id;
        const response = await axios.get(
          `${config.baseURL}/site/organization?organizationId=${orgId}`,
          { withCredentials: true }
        );

        if (Array.isArray(response.data)) {
          sites = response.data;
        }
      }

      // SET SITES LIST FIRST
      setSitesList(sites);
      setSelectedSite(sites[0]?.id);

      if (selectedTab === 2) {
        getRoutesUnderSites(sites[0]?.id);
      }

      const listOfVehicles = [];
      sites?.forEach((s) => {
        if (Array.isArray(s?.vehicles)) {
          listOfVehicles.push(...s.vehicles);
        }
      });

      try {
        const date = stringToDate("today");
        let startTime = "00:00:00";
        let endTime = "12:00:00";

        // PASS BOTH SITES AND INITIAL SITE ID
        await handleCallLocationData("initialCall", {
          sTime: startTime,
          eTime: endTime,
          sDate: null,
          eDate: null,
          dRange: "today",
          newDate: date,
          initialSites: sites,
          initialSiteId: sites[0]?.id, // ADD THIS
        });
      } catch (e) {
        console.log("something went wrong during fetching vehicle");
      }
    } catch (error) {
      console.error("Something went wrong in fetching sites", error);
      if (error.response && error.response.status === 401) {
        navigate("/");
      }
    } finally {
      setSitesLoading(false);
    }
  };

  useEffect(() => {
    if (selectedDateRange === "custom") {
      const today = dayjs().format("YYYY-MM-DD");
      if (!endDate) {
        setEndDate(today);
      }
      if (!startDate) {
        setStartDate(today);
        generateCustomDates();
      }
      if (!startDate && !endDate) {
        generateCustomDates(today, today);
      } else if (!startDate && endDate) {
        generateCustomDates(today, endDate);
      } else if (!endDate && startDate) {
        generateCustomDates(startDate, today);
      }
    }
  }, [selectedDateRange]);

  const handleTabChange = (event, newValue) => {
    if (selectedDateRange === "custom") {
      const today = dayjs().format("YYYY-MM-DD");
      if (!endDate) {
        setEndDate(today);
      }
      if (!startDate) {
        setStartDate(today);
      }
      if (!startDate && !endDate) {
        generateCustomDates(today, today);
      } else if (!startDate && endDate) {
        generateCustomDates(today, endDate);
      } else if (!endDate && startDate) {
        generateCustomDates(startDate, today);
      }
    }
    setSelectedTab(newValue);
    setLocation([]);
    if (newValue === 2) {
      // setRouteList([]);
      getRoutesUnderSites(selectedSite);
    }

    if (newValue === 0 || newValue === 1) {
      handleCallLocationData("handleTabChange", { newValue });
    }
    // setSelectedVehicle({
    //   previousTab: newValue,
    //   vehicleId: selectedVehicles[selectedVehicles?.length - 1],
    // });
    // if (newValue === 2) {
    //   setSelectedVehicles([]);
    // } else {
    //   if (selectedVehicle?.previousTab === 2 && selectedVehicle?.vehicleId) {
    //     setSelectedVehicles([selectedVehicle?.vehicleId]);
    //   }
    // }
    // setSelectedVehicles([]);
  };

  const getDemoVehicle = () => {
    const vehicles =
      dashboardJson?.dashboard?.dashboard?.["api/vehicle/organization"];
    const normalizedVehicles = getUniqueVehiclesByDeviceId(vehicles);
    allVehiclesRef.current = normalizedVehicles;
    setVehicleLoading(false);
    if (selectedTab === 1) {
      setVehicleList(normalizedVehicles);
    }
    return normalizedVehicles;
  };

  const getVehicle = async () => {
    if (getIsDemo()) {
      return getDemoVehicle();
    }

    try {
      const response = await axios.get(`${config.baseURL}/vehicle/organization`, {
        withCredentials: true,
      });

      let vehicles = [];
      if (Array.isArray(response.data)) {
        vehicles = response.data;
      } else if (Array.isArray(response.data.vehicles)) {
        vehicles = response.data.vehicles;
      }

      const normalizedVehicles = getUniqueVehiclesByDeviceId(vehicles);
      allVehiclesRef.current = normalizedVehicles;

      if (selectedTab === 1) {
        setVehicleList(normalizedVehicles);
      }

      return normalizedVehicles;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate("/");
      }
      return [];
    } finally {
      setVehicleLoading(false);
    }
  };

  const getRoute = () => {
    if (getIsDemo()) {
      const route = replayJson?.replay?.["/route/organization"];
      setRouteList(route);
      return;
    }
    axios
      .get(`${config.baseURL}/route/organization`, { withCredentials: true })
      .then((response) => {
        let route = [];
        if (Array.isArray(response.data)) {
          route = response.data;
        } else if (Array.isArray(response.data.vehicles)) {
          route = response.data.vehicles;
        }
        setRouteList(route);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          navigate("/");
        }
      });
  };

  useEffect(() => {
    const initializeReplay = async () => {
      await getVehicle();
      if (selectedTab !== 2) {
        getRoute();
      }
      getSites();
    };

    initializeReplay();
  }, []);

  const GetTrip = async (value, dateOption, dateRange = null, type) => {
    if (
      (type !== "onTabChangeTripCall" || type !== "changeOnSiteChange") &&
      selectedTab !== 1
    ) {
      return;
    }
    const orgId = JSON.parse(localStorage.getItem("userState"))?.organization
      ?.id;

    if (!value?.length) {
      console.log("value", value);
      setReportData([]);
      return;
    }
    try {
      let customStartDate = null;
      let customEndDate = null;

      if (type === "onTabChangeTripCall" && dateOption === "custom") {
        customStartDate = dateRange?.startDate;
        customEndDate = dateRange?.endDate;
      }
      let allVehicles = false;
      if (type !== "onTabChangeTripCall") {
        if (vehicleList?.length === value?.length) {
          allVehicles = true;
        }
      }

      if (type === "startDate") {
        customStartDate = dateRange;
        customEndDate = endDate;
      } else if (type === "endDate") {
        customStartDate = startDate;
        customEndDate = dateRange;
      }

      if (type === "changeOnSiteChange") {
        allVehicles = false;
      }
      if (type === "changeOnSiteChange" && dateOption === "custom") {
        customStartDate = dateRange?.startDate;
        customEndDate = dateRange?.endDate;
      }

      if (dateOption === "custom" && (!customStartDate || !customEndDate)) {
        return;
      }
      console.log(value, "checkIn");
      const params = {
        orgId: orgId,
        siteId: null,
        category: "vehicles",
        selectedIds: !allVehicles ? value : [],
        selectAll: allVehicles,
        dateOption: dateOption,
        customStartDate,
        customEndDate,
      };
      setLoadingTrip(true);
      const data = await reportsApi.getTripReport(params);
      //   console.log(data?.data)
      const updatedData = data?.data?.map((trip, index) => ({
        ...trip,
        id: index + 1,
      }));
      if (!updatedData.length) {
        // setErrorMessage((prev) => ({
        //   ...prev,
        //   tripList: "No Trip Available",
        // }));
      } else {
        setErrorMessage((prev) => ({
          ...prev,
          tripList: null,
        }));
      }
      setReportData(updatedData);
    } catch (e) {
      setReportData([]);
      console.log(e);
    } finally {
      setLoadingTrip(false);
    }
  };

  const handleVehicleChange = (event) => {
    let { value } = event.target;
    value = Array.isArray(value) ? value : [value];
    console.log("value", value, selectedVehicles);
    if (value.length) {
      setErrorMessage((prev) => ({
        ...prev,
        vehicleSelected: null,
      }));
    }
    if (value.length > 2 && value.includes("select-all")) {
      setErrorMessage((prev) => ({
        ...prev,
        vehicleSelected: "No vehicles assigned to this site yet",
      }));
    }
    // Handle "Select All" case
    if (value[value.length - 1] === "select-all") {
      const newSelectedVehicles =
        selectedVehicles.length === uniqueVehicleList.length
          ? []
          : getUniqueValues(
              uniqueVehicleList
                .map((vehicle) => getVehicleDeviceId(vehicle))
                .filter(Boolean)
            );
      setSelectedVehicles(newSelectedVehicles);
      setSelectedTrip("");

      if (newSelectedVehicles.length && selectedDateRange) {
        if (selectedDateRange !== "custom") {
          GetTrip(newSelectedVehicles, selectedDateRange);
        } else {
          GetTrip(
            newSelectedVehicles,
            selectedDateRange,
            startDate,
            "startDate"
          );
        }
      }
      return;
    }

    setSelectedVehicles(getUniqueValues(value));
    setSelectedTrip("");

    if (value.length && selectedDateRange) {
      if (selectedDateRange !== "custom") {
        GetTrip(value, selectedDateRange);
      } else {
        GetTrip(value, selectedDateRange, startDate, "startDate");
      }
    }
  };

  const handleDateRangeChange = (event) => {
    setSelectedDateRange(event.target.value);
    if (selectedVehicles.length && event.target.value) {
      GetTrip([selectedVehicles[0]], event.target.value);
    }
    let date;
    if (event.target.value === "today" || event.target.value === "yesterday") {
      date = stringToDate(event.target.value);
      handleCallLocationData("selectedDateRange", {
        sTime: null,
        eTime: null,
        sDate: startDate,
        eDate: endDate,
        dRange: event.target.value,
        newDate: date,
      });
    } else if (
      event.target.value === "last 7 days" ||
      event.target.value === "last 30 days"
    ) {
      let { endDate, startDate } = stringToDate(event.target.value);
      handleCallLocationData("selectedDateRange", {
        sTime: null,
        eTime: null,
        sDate: startDate,
        eDate: endDate,
        dRange: event.target.value,
        newDate: date,
      });
    } else if (event.target.value === "custom") {
      handleCallLocationData("selectedDateRange", {
        sTime: null,
        eTime: null,
        sDate: null,
        eDate: null,
        dRange: event.target.value,
        newDate: null,
      });
    }
  };
  // 🧩 Reusable date validation helper
  const validateDateRange = (startDate, endDate, fieldType) => {
    const today = new Date();

    // 1️⃣ Validate start date not after end date
    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      setErrorMessage((prev) => ({
        ...prev,
        startDate: "Start date cannot be after end date.",
        endDate: "", // clear endDate error
      }));
      return false;
    }

    // 2️⃣ Validate end date not before start date
    if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
      setErrorMessage((prev) => ({
        ...prev,
        endDate: "End date cannot be before start date.",
        startDate: "", // clear startDate error
      }));
      return false;
    }
    setErrorMessage((prev) => ({
      ...prev,
      startDate: "",
      endDate: "",
    }));
    // 3️⃣ Optional — block future dates
    // const targetDate =
    //   fieldType === "start" ? new Date(startDate) : new Date(endDate);
    // if (targetDate > today) {
    //   alert("Future dates are not allowed.");
    //   return false;
    // }

    // 4️⃣ Optional — limit max range to 30 days
    // if (startDate && endDate) {
    //   const diffDays =
    //     (new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24);
    //   if (diffDays > 30) {
    //     alert("Please select a date range of up to 30 days.");
    //     return false;
    //   }
    // }

    return true;
  };

  const handleStartDateChange = (event) => {
    if (!event.target.value) return;
    setStartDate(event.target.value);
    if (!validateDateRange(event.target.value, endDate, "start")) return;

    generateCustomDates(event.target.value, endDate);
    if (selectedVehicles.length && event.target.value && endDate) {
      GetTrip(
        selectedVehicles,
        selectedDateRange,
        event.target.value,
        "startDate"
      );
    }
    handleCallLocationData("startDate", {
      sTime: null,
      eTime: null,
      sDate: event.target.value,
      eDate: null,
      dRange: null,
      newDate: null,
    });
  };

  const handleEndDateChange = (event) => {
    if (!event.target.value) return;
    setEndDate(event.target.value);
    if (!validateDateRange(startDate, event.target.value, "end")) return;

    generateCustomDates(startDate, event.target.value);
    if (selectedVehicles.length && event.target.value && startDate) {
      GetTrip(
        selectedVehicles,
        selectedDateRange,
        event.target.value,
        "endDate"
      );
    }
    handleCallLocationData("endDate", {
      sTime: null,
      eTime: null,
      sDate: null,
      eDate: event.target.value,
      dRange: null,
      newDate: null,
    });
  };

  // Generate all dates between start & end for custom selection

  const generateCustomDates = (start, end) => {
    if (!start || !end) return;

    const startDay = dayjs(start);
    const endDay = dayjs(end);
    let tempDates = {};

    for (
      let d = startDay;
      d.isBefore(endDay) || d.isSame(endDay, "day");
      d = d.add(1, "day")
    ) {
      const dateStr = d.format("YYYY-MM-DD");
      tempDates[dateStr] = customDateTimes[dateStr] || { start: "", end: "" };
    }
    // console.log("tempDates",tempDates)
    setCustomDateTimes(tempDates);
  };

  const handleCustomTimeChange = (date, field, value) => {
    setCustomDateTimes((prev) => ({
      ...prev,
      [date]: { ...prev[date], [field]: value },
    }));
  };

  // Handle trip selection
  const handleTripChange = (event) => {
    if (event.target.value) {
      setErrorMessage((prev) => ({
        ...prev,
        tripList: null,
      }));
    }
    setSelectedTrip(event.target.value);
    // setCurrentPositionIndex(0);
  };

  const handleRouteChange = (event) => {
    const value = event.target.value;

    // Handle "Select All" and "Deselect All"
    if (value.includes("all")) {
      if (selectedRoute.length === routeList.length) {
        setSelectedRoute([]); // Deselect All
        setSelectedVehicles([]);
      } else {
        setSelectedRoute(getUniqueValues(routeList.map((route) => route.id))); // Select All
      }
    } else {
      setSelectedRoute(getUniqueValues(value));
    }
  };

  const findTripDetails = (tripId) => {
    const trip = reportData?.find((t) => t.id === tripId);
    if (trip) return trip;
    return null;
  };

  const fetchStopsForRoute = async (route) => {
    const orgId = JSON.parse(localStorage.getItem("userState"))?.organization
      ?.id;
    let stops = [];
    for (const coordinate of route.routeCoordinates) {
      try {
        if (getIsDemo()) {
          const stopData = replayJson?.replay?.[
            "stop/organization/location"
          ]?.filter(
            (s) =>
              s?.longitude === coordinate.longitude &&
              s?.latitude === coordinate.latitude
          );
          if (Array.isArray(stopData)) {
            stops.push(...stopData);
          }
        } else {
          const stopsResponse = await axios.get(
            `${config.baseURL}/stop/organization/location`,
            {
              params: {
                organizationId: orgId,
                longitude: coordinate.longitude,
                latitude: coordinate.latitude,
              },
              withCredentials: true,
            }
          );
          if (Array.isArray(stopsResponse.data)) {
            stops.push(...stopsResponse.data);
          } else if (stopsResponse.data) {
            stops.push(stopsResponse.data);
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.log("Unauthorized request");
          navigate("/");
          return;
        }
        console.log("Error in fetching stops by coordinates", error);
      }
    }
    return getUniqueStopsById(stops);
  };

  const fetchLocationData = async (
    deviceIds,
    startTime,
    endTime,
    date,
    endDate,
    startDate,
    selectedDateRange,
    customDateList = [],
    selectedTab = null,
    siteId = null
  ) => {
    try {
      let response;
      if (deviceIds.length > 0) {
        response = await axios.post(
          `${config.baseURL}/location/all`,
          { customDates: customDateList },
          {
            params: {
              deviceIds: deviceIds.join(","),
              date,
              startTime,
              endTime,
              endDate,
              startDate,
              selectedDateRange,
              selectedTab,
            },
            withCredentials: true,
          }
        );
        return response.data;
      } else {
        const siteToCheck = siteId || selectedSite;
        if (!siteToCheck) {
          alert("Site s missing");
          return;
        }
        response = await axios.post(
          `${config.baseURL}/location/all/deviceid`,
          { customDates: customDateList },
          {
            params: {
              date,
              startTime,
              endTime,
              endDate,
              startDate,
              selectedDateRange,
              selectedTab,
            },
            withCredentials: true,
          }
        );
        console.log("debug", response.data);
        return { data: response.data, noDevice: true };
      }
    } catch (error) {
      setLocationLoader(false);
      console.error("Error fetching location data:", error, deviceIds);
    } finally {
      setLocationLoader(false);
    }
  };

  const stringToDate = (selectedDateRange) => {
    let endDate = "";
    let startDate = "";
    if (selectedDateRange === "today") {
      return dayjs().format("DD/MM/YYYY");
    } else if (selectedDateRange === "yesterday") {
      return dayjs().subtract(1, "day").format("DD/MM/YYYY");
    } else if (selectedDateRange === "last 7 days") {
      endDate = dayjs().subtract(1, "day").format("DD/MM/YYYY"); // yesterday
      startDate = dayjs().subtract(7, "day").format("DD/MM/YYYY"); // 7 days before yesterday
      return { endDate, startDate };
    } else if (selectedDateRange === "last 30 days") {
      endDate = dayjs().subtract(1, "day").format("DD/MM/YYYY"); // yesterday
      startDate = dayjs().subtract(30, "day").format("DD/MM/YYYY"); // 30 days before yesterday
      return { endDate, startDate };
    }
  };

  const dateAndTime = (type = null, dateRange) => {
    const range = type ? dateRange : selectedDateRange;
    let startTime = String(timeRange?.start)?.split(" ")[4] || "00:00:00";
    let endTime = String(timeRange?.end)?.split(" ")[4] || "12:00:00";
    let date = "";
    // console.log(range);
    if (range === "today" || range === "yesterday") {
      date = stringToDate(range);
      // console.log("checking",startTime, endTime, date)
      return { startTime, endTime, date };
    } else if (range === "last 7 days" || range === "last 30 days") {
      let { endDate, startDate } = stringToDate(range);
      return { startTime, endTime, date, endDate, startDate };
    }
  };

  const filterCustomDate = (type = null, tempData) => {
    let customDate = type ? { ...tempData } : { ...customDateTimes };

    if (!customDate || Object.keys(customDate).length === 0) {
      const today = new Date();
      const key = today.toISOString().split("T")[0]; // format: YYYY-MM-DD
      customDate = {
        [key]: {
          start: new Date(today.setHours(0, 0, 0, 0)), // 12:00 AM
          end: new Date(today.setHours(12, 0, 0, 0)), // 12:00 PM
        },
      };
    }
    const arr = [];

    Object.entries(customDate).forEach(([key, value]) => {
      let startTime = String(value?.start)?.split(" ")[4] || "00:00:00";
      let endTime = String(value?.end)?.split(" ")[4] || "12:00:00";
      const [year, month, day] = key.split("-");
      const date = `${day}/${month}/${year}`;
      arr.push({
        date,
        startTime,
        endTime,
      });
    });
    arr.sort((a, b) => {
      const [dayA, monthA, yearA] = a.date.split("/").map(Number);
      const [dayB, monthB, yearB] = b.date.split("/").map(Number);

      const dateA = new Date(yearA, monthA - 1, dayA);
      const dateB = new Date(yearB, monthB - 1, dayB);

      return dateA - dateB; // ascending order
    });

    return arr;
  };
  const dateConverter = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "";

    if (dateStr.includes("-")) {
      const [year, month, day] = dateStr.split("-");
      return `${day}/${month}/${year}`;
    }

    const parts = dateStr.split("/");
    if (parts.length !== 3) {
      return dateStr;
    }

    // Already DD/MM/YYYY
    if (parts[2]?.length === 4) {
      return dateStr;
    }

    const [year, month, day] = parts;
    return `${day}/${month}/${year}`;
  };
  const getLocationDataWithFilter = async (deviceId, type = null) => {
    const selectVehiclesList =
      type === "handleSelectSite" ? [] : selectedVehicles;
    if (selectedTab === 0 && selectedDateRange === "custom") {
      const customDateList = filterCustomDate();
      return await fetchLocationData(
        selectVehiclesList,
        "",
        "",
        "",
        "",
        "",
        selectedDateRange,
        customDateList
      );
    } else if (selectedTab === 1 && selectedDateRange === "custom") {
      const updateDate = findTripDetails(selectedTrip)?.date
        ? dateConverter(findTripDetails(selectedTrip)?.date)
        : date;

      return await fetchLocationData(
        selectVehiclesList,
        findTripDetails(selectedTrip)?.startTime,
        findTripDetails(selectedTrip)?.endTime,
        updateDate,
        "",
        "",
        "today",
        [],
        selectedTab
      );
    } else if (selectedTab === 2 && selectedDateRange === "custom") {
      const customDateList = filterCustomDate();
      return await fetchLocationData(
        selectedVehicles,
        "",
        "",
        "",
        "",
        "",
        selectedDateRange,
        customDateList
      );
    }

    let { startTime, endTime, date, endDate, startDate } = dateAndTime();

    if (
      selectedTab === 0 &&
      (selectedDateRange === "today" || selectedDateRange === "yesterday")
    ) {
      return await fetchLocationData(
        selectVehiclesList,
        startTime,
        endTime,
        date,
        (endDate = ""),
        (startDate = ""),
        selectedDateRange
      );
    } else if (
      selectedTab === 1 &&
      (selectedDateRange === "last 7 days" ||
        selectedDateRange === "last 30 days")
    ) {
      return await fetchLocationData(
        selectVehiclesList,
        startTime,
        endTime,
        (date = ""),
        endDate,
        startDate,
        selectedDateRange
      );
    } else if (
      selectedTab === 0 &&
      (selectedDateRange === "last 7 days" ||
        selectedDateRange === "last 30 days")
    ) {
      return await fetchLocationData(
        selectVehiclesList,
        startTime,
        endTime,
        (date = ""),
        endDate,
        startDate,
        selectedDateRange
      );
    } else if (
      selectedTab === 2 &&
      (selectedDateRange === "last 7 days" ||
        selectedDateRange === "last 30 days")
    ) {
      return await fetchLocationData(
        deviceId,
        startTime,
        endTime,
        (date = ""),
        endDate,
        startDate,
        selectedDateRange
      );
    } else if (
      selectedTab === 2 &&
      (selectedDateRange === "today" || selectedDateRange === "yesterday")
    ) {
      return await fetchLocationData(
        deviceId,
        startTime,
        endTime,
        date,
        (endDate = ""),
        (startDate = ""),
        selectedDateRange
      );
    }
    //  else if (
    //   selectedTab === 1 &&
    //   (selectedDateRange === "last 7 days" ||
    //     selectedDateRange === "last 30 days")
    // ) {
    //   return await fetchLocationData(
    //     selectedVehicles,
    //     startTime,
    //     endTime,
    //     (date = ""),
    //     endDate,
    //     startDate,
    //     selectedDateRange
    //   );
    // }
    else {
      const updateDate = findTripDetails(selectedTrip)?.date
        ? dateConverter(findTripDetails(selectedTrip)?.date)
        : date;
      return await fetchLocationData(
        selectVehiclesList,
        findTripDetails(selectedTrip)?.startTime || startTime,
        findTripDetails(selectedTrip)?.endTime || endTime,
        updateDate,
        (endDate = ""),
        (startDate = ""),
        "today",
        [],
        selectedTab
      );
    }
  };

  const fetchRoutes = async (routeId) => {
    try {
      let route = [];
      if (getIsDemo()) {
        route = replayJson?.replay?.["/route/organization"]?.filter(
          (routeId) => routeId?.id === parseInt(routeId)
        );
      } else {
        const orgId = JSON.parse(localStorage.getItem("userState"))
          ?.organization?.id;
        const routesResponse = await axios.get(
          `${config.baseURL}/route/id?id=${routeId}`,
          {
            params: { organizationId: orgId },
            withCredentials: true,
          }
        );
        if (routesResponse.status === 401) {
          console.log("Unauthorized request");
          navigate("/");
          return;
        }
        route = routesResponse?.data;
      }

      const stops = await fetchStopsForRoute(route);
      const resolvedRouteVehicles = resolveVehiclesFromSource(route?.vehicles);
      const routesWithStops = {
        ...route,
        stops,
        vehicles: resolvedRouteVehicles,
      };

      const filterVehicle = resolvedRouteVehicles?.filter((vehicle) => {
        return selectedVehicles?.find(
          (selectedVehicleId) =>
            selectedVehicleId === getVehicleDeviceId(vehicle)
        );
      });

      setRouteData({
        ...routesWithStops,
        vehicles: selectedTab !== 2 ? filterVehicle : resolvedRouteVehicles,
      });
      const deviceId =
        selectedTab === 2
          ? resolvedRouteVehicles?.map((vehicle) => getVehicleDeviceId(vehicle))
          : [];
      const locationData = await getLocationDataWithFilter(deviceId);
      if (selectedTab === 2) {
        setSelectedVehicles(getUniqueValues(deviceId));
      }
      if (!locationData.length) {
        setShowAlert(true);
        setAlertMessage("No Location Data Found");
      }
      setLocation(locationData);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.log("Unauthorized request");
        navigate("/");
        return;
      }
      console.log("Error in fetching routes by organization", error);
    } finally {
      setLocationLoader(false);
    }
  };

  const fetchMultipleRoutes = async (routeId) => {
    const orgId = JSON.parse(localStorage.getItem("userState"))?.organization
      ?.id;
    try {
      const routesResponse = await axios.get(`${config.baseURL}/route/id`, {
        params: { id: routeId, organizationId: orgId },
        withCredentials: true,
      });

      if (routesResponse.status === 401) {
        navigate("/");
        return null;
      }

      const route = routesResponse.data;
      const stops = await fetchStopsForRoute(route);
      const resolvedRouteVehicles = resolveVehiclesFromSource(route?.vehicles);
      const routesWithStops = {
        ...route,
        stops,
        vehicles: resolvedRouteVehicles,
      };

      const filterVehicle = resolvedRouteVehicles?.filter((vehicle) =>
        selectedVehicles.includes(getVehicleDeviceId(vehicle))
      );

      const routeData = {
        ...routesWithStops,
        vehicles: selectedTab !== 2 ? filterVehicle : resolvedRouteVehicles,
      };

      const deviceId =
        selectedTab === 2
          ? resolvedRouteVehicles.map((vehicle) => getVehicleDeviceId(vehicle))
          : [];
      // console.log(deviceId)
      const locationData = await getLocationDataWithFilter(deviceId);

      // ✅ return combined result instead of setting directly
      return { ...routeData, locations: locationData };
    } catch (error) {
      console.error("Error fetching route:", error);
      return null;
    } finally {
      setLocationLoader(false);
    }
  };

  const validate = () => {
    switch (selectedTab) {
      case 0:
        if (selectedVehicles.length) {
          setErrorMessage((prev) => ({
            ...prev,
            vehicleSelected: null,
          }));
        }
        if (!selectedVehicles.length) {
          setErrorMessage((prev) => ({
            ...prev,
            vehicleSelected: "Vehicle is Missing",
          }));
          return true;
        }
        break;
      case 1:
        if (!selectedVehicles.length) {
          setShowAlert(true);
          setAlertMessage("Vehicle is Missing");
          return true;
        }
        if (!selectedTrip) {
          setErrorMessage((prev) => ({
            ...prev,
            tripList: "No Trip Selected",
          }));
          return true;
        } else {
          setErrorMessage((prev) => ({
            ...prev,
            tripList: null,
          }));
          return false;
        }
      case 2:
        if (!selectedRoute.length) {
          // setShowAlert(true);
          // setAlertMessage("Route is Missing");
          setErrorMessage((prev) => ({
            ...prev,
            routesList: "Route is Missing",
          }));
          return true;
        } else {
          setErrorMessage((prev) => ({
            ...prev,
            routesList: null,
          }));
          return false;
        }
        break;
      default:
        break;
    }
    return false;
  };

  const handleSubmit = async () => {
    if (validate()) {
      return;
    }
    setLocationLoader(true);
    try {
      switch (selectedTab) {
        case 1:
          if (findTripDetails(selectedTrip)?.routeId) {
            await fetchRoutes(findTripDetails(selectedTrip)?.routeId);
          } else {
            return;
          }
          break;
        case 2:
          if (selectedRoute.length) {
            const allRoutesData = await Promise.all(
              selectedRoute.map(async (routeId) => {
                return await fetchMultipleRoutes(routeId);
              })
            );
            const combinedRoutes = allRoutesData.flat().filter(Boolean);
            const allLocations = combinedRoutes.flatMap(
              (r) => r?.locations || []
            );
            console.log(combinedRoutes, allLocations);
            if (!allLocations.length) {
              setShowAlert(true);
              setAlertMessage("No Location Data Found");
            }
            if (selectedTab === 2) {
              const vehicles = [];
              const vehiclesInfo = [];
              combinedRoutes.forEach((v) => {
                const vehicleList = v?.vehicles?.filter(Boolean);
                vehiclesInfo?.push(...vehicleList);
              });
              combinedRoutes.forEach((v) => {
                const vehicleList = v?.vehicles
                  ?.map((vehicle) => getVehicleDeviceId(vehicle))
                  .filter(Boolean);
                vehicles?.push(...vehicleList);
              });

              setVehicleList(getUniqueVehiclesByDeviceId(vehiclesInfo));
              setSelectedVehicles(getUniqueValues(vehicles));
            }
            setRouteData(combinedRoutes);
            setLocation(allLocations);
          } else {
            return;
          }
          break;
        default:
          if (selectedVehicles?.length) {
            const routeIds = [
              ...new Set(
                vehicleList
                  ?.filter((vehicle) =>
                    selectedVehicles.includes(getVehicleDeviceId(vehicle))
                  )
                  ?.map((v) => v.routeId)
                  ?.filter(Boolean)
              ),
            ];

            if (routeIds.length) {
              const allRoutesData = await Promise.all(
                routeIds.map(async (routeId) => {
                  return await fetchMultipleRoutes(routeId);
                })
              );
              const combinedRoutes = allRoutesData.flat().filter(Boolean);
              const allLocations = combinedRoutes.flatMap(
                (r) => r?.locations || []
              );

              setRouteData(combinedRoutes);
              setLocation(allLocations);
            }
          }

          break;
      }
    } finally {
      setLocationLoader(false);
    }
  };

  // Clean up interval on unmount
  useEffect(() => {
    return () => {
      if (playbackIntervalRef.current) {
        clearInterval(playbackIntervalRef.current);
      }
    };
  }, []);

  // ...existing code...
  const handleSelectSites = async (e) => {
    setSelectedSite(e.target.value);
    const selectedSiteDetails = sitesList?.find(
      (s) => s?.id === parseInt(e?.target?.value)
    );

    // Get location response robustly (could be array or { data: [...] })
    const locRes =
      (await getLocationDataWithFilter([], "handleSelectSite")) || {};
    const locationData = Array.isArray(locRes) ? locRes : locRes.data || [];

    // Normalize device ids to string before comparing
    const locationDeviceIds = (locationData || [])
      .map((item) => (item?.device_id != null ? String(item.device_id) : null))
      .filter(Boolean);

    const siteVehicles = resolveVehiclesFromSource(
      selectedSiteDetails?.vehicles || []
    );
    const filteredVehicles =
      siteVehicles?.filter((vehicleItem) =>
        locationDeviceIds.includes(getVehicleDeviceId(vehicleItem))
      ) || [];
    const deviceId = filteredVehicles
      ?.map((vehicleItem) => getVehicleDeviceId(vehicleItem))
      .filter(Boolean);

    if (selectedTab === 2) {
      getRoutesUnderSites(e.target.value);
    }

    if (selectedTab === 1) {
      setSelectedVehicles(getUniqueValues([deviceId[0]]));
    } else {
      setSelectedVehicles(getUniqueValues(deviceId));
    }

    if (deviceId[0]) {
      const customDateList = filterCustomDate();

      const dateRange = {
        startDate: startDate,
        endDate: endDate,
      };
      GetTrip(
        [deviceId[0]],
        selectedDateRange,
        dateRange,
        "changeOnSiteChange"
      );
    }

    if (!filteredVehicles.length) {
      setErrorMessage((prev) => ({
        ...prev,
        vehicleSelected: "No vehicles assigned to this site yet",
      }));
    } else {
      setErrorMessage((prev) => ({
        ...prev,
        vehicleSelected: null,
      }));
    }

    setVehicleList(getUniqueVehiclesByDeviceId(filteredVehicles));
  };

  const getInstantData = (start, end) => {
    if (!start || !end) return;

    const startDay = dayjs(start);
    const endDay = dayjs(end);
    let tempDates = {};

    for (
      let d = startDay;
      d.isBefore(endDay) || d.isSame(endDay, "day");
      d = d.add(1, "day")
    ) {
      const dateStr = d.format("YYYY-MM-DD");
      tempDates[dateStr] = customDateTimes[dateStr] || { start: "", end: "" };
    }
    return tempDates;
  };

  const handleCallLocationData = async (
    type,
    {
      sTime,
      eTime,
      sDate,
      eDate,
      dRange,
      newDate,
      newValue,
      initialSites,
      initialSiteId,
    }
  ) => {
    const sitesToUse = initialSites || sitesList;
    const siteIdToUse = initialSiteId || selectedSite;
    if (sitesToUse?.length <= 0) {
      return;
    }
    const selectedSiteDetails = sitesToUse?.find(
      (site) => site?.id === parseInt(siteIdToUse)
    );
    const customDateList = filterCustomDate();
    let locData;
    if (type === "selectedDateRange") {
      let { startTime, endTime, date, endDate, startDate } =
        dateAndTime((type = true), dRange) || {};

      if (dRange === "today" || dRange === "yesterday") {
        locData = await fetchLocationData(
          [],
          startTime,
          endTime,
          newDate,
          endDate,
          startDate,
          dRange,
          customDateList,
          selectedTab
        );
      } else if (dRange === "last 7 days" || dRange === "last 30 days") {
        locData = await fetchLocationData(
          [],
          startTime,
          endTime,
          newDate,
          eDate,
          sDate,
          dRange,
          customDateList
          // selectedTab
        );
      } else if (dRange === "custom") {
        locData = await fetchLocationData(
          [],
          startTime,
          endTime,
          newDate,
          endDate,
          startDate,
          dRange,
          customDateList
          // selectedTab
        );
      }
    } else if (type === "startTime") {
      let { endTime, date, endDate, startDate } = dateAndTime() || {};

      locData = await fetchLocationData(
        [],
        sTime,
        endTime,
        date,
        endDate,
        startDate,
        selectedDateRange,
        customDateList,
        selectedTab
      );
    } else if (type === "endTime") {
      let { startTime, date, endDate, startDate } = dateAndTime() || {};

      locData = await fetchLocationData(
        [],
        startTime,
        eTime,
        date,
        endDate,
        startDate,
        selectedDateRange,
        customDateList,
        selectedTab
      );
    } else if (type === "endDate") {
      let { startTime, endTime, date } = dateAndTime() || {};
      const customDateList = filterCustomDate(
        (type = true),
        getInstantData(startDate, eDate)
      );
      if (selectedDateRange === "custom") {
        locData = await fetchLocationData(
          [],
          startTime,
          endTime,
          date,
          eDate,
          startDate,
          selectedDateRange,
          customDateList,
          selectedTab
        );
      } else {
        locData = await fetchLocationData(
          [],
          startTime,
          endTime,
          date,
          eDate,
          startDate,
          selectedDateRange,
          customDateList,
          selectedTab
        );
      }
    } else if (type === "startDate") {
      let { startTime, endTime, date } = dateAndTime() || {};
      const customDateList = filterCustomDate(
        (type = true),
        getInstantData(sDate, endDate)
      );

      if (selectedDateRange === "custom") {
        console.log(endDate, sDate);
        locData = await fetchLocationData(
          [],
          startTime,
          endTime,
          date,
          endDate,
          sDate,
          selectedDateRange,
          customDateList,
          selectedTab
        );
      } else {
        locData = await fetchLocationData(
          [],
          startTime,
          endTime,
          date,
          endDate,
          sDate,
          selectedDateRange,
          customDateList,
          selectedTab
        );
      }
    } else if (type === "initialCall") {
      locData = await fetchLocationData(
        [],
        sTime,
        eTime,
        newDate,
        endDate,
        startDate,
        dRange,
        customDateList,
        selectedTab,
        siteIdToUse
      );
      if (selectedTab === 1 || true) {
        GetTrip(selectedVehicles, selectedDateRange, "", "endDate");
      }
    } else if (type === "handleTabChange") {
      let { startTime, endTime, date, endDate, startDate } =
        dateAndTime() || {};
      if (selectedDateRange === "today" || selectedDateRange === "yesterday") {
        locData = await fetchLocationData(
          [],
          startTime,
          endTime,
          date,
          (endDate = null),
          (startDate = null),
          selectedDateRange,
          [],
          newValue
        );
      } else if (
        selectedDateRange === "last 7 days" ||
        selectedDateRange === "last 30 days"
      ) {
        locData = await fetchLocationData(
          [],
          startTime,
          endTime,
          "",
          endDate,
          startDate,
          selectedDateRange,
          []
          // selectedTab
        );
      } else if (selectedDateRange === "custom") {
        locData = await fetchLocationData(
          [],
          startTime,
          endTime,
          "",
          "",
          "",
          selectedDateRange,
          customDateList
          // selectedTab
        );
      }
    }
    const { data: locationData } = locData || {};
    const locationDeviceIds =
      locationData
        ?.map((item) =>
          item?.device_id !== undefined && item?.device_id !== null
            ? String(item.device_id)
            : null
        )
        .filter(Boolean) || [];

    const siteVehicles = resolveVehiclesFromSource(
      selectedSiteDetails?.vehicles || []
    );
    const filteredVehicles =
      siteVehicles?.filter((vehicleItem) =>
        locationDeviceIds.includes(getVehicleDeviceId(vehicleItem))
      ) || [];
    const deviceId = getUniqueValues(
      filteredVehicles
        ?.map((vehicleItem) => getVehicleDeviceId(vehicleItem))
        .filter(Boolean)
    );
    if (!filteredVehicles.length) {
      setErrorMessage((prev) => ({
        ...prev,
        vehicleSelected: "No vehicles assigned to this site yet",
      }));
    } else {
      setErrorMessage((prev) => ({
        ...prev,
        vehicleSelected: null,
      }));
    }

    let deviceidList =
      type === "handleTabChange" && newValue && newValue === 1
        ? deviceId.length
          ? []
          : []
        : deviceId;

    if (type === "handleTabChange" && newValue && newValue === 1) {
      const dateRange = {
        startDate: startDate,
        endDate: endDate,
      };

      GetTrip(
        deviceidList,
        selectedDateRange,
        dateRange,
        (type = "onTabChangeTripCall")
      );
    }

    // if (!filteredVehicles?.length) {
    //   setErrorMessage((prev) => ({
    //     ...prev,
    //     vehicleSelected: "No Vehicles Available",
    //   }));
    // } else {
    //   setErrorMessage((prev) => ({
    //     ...prev,
    //     vehicleSelected: null,
    //   }));
    // }

    setSelectedVehicles(getUniqueValues(deviceidList));
    setVehicleList(getUniqueVehiclesByDeviceId(filteredVehicles));
  };

  const dates = Object.keys(customDateTimes);
  const firstDate = dates[0];
  const lastDate = dates[dates.length - 1];

  useEffect(() => {
    if (!firstDate || !lastDate) return;

    setCustomDateTimes((prev) => {
      // both dates are same → merge start and end under one key
      if (firstDate === lastDate) {
        return {
          ...prev,
          [firstDate]: {
            start:
              prev[firstDate]?.start ||
              new Date(new Date().setHours(0, 0, 0, 0)), // default 12 AM
            end:
              prev[firstDate]?.end ||
              new Date(new Date().setHours(12, 0, 0, 0)), // default 12 PM
          },
        };
      }

      // different dates → normal case
      return {
        ...prev,
        [firstDate]: {
          start:
            prev[firstDate]?.start || new Date(new Date().setHours(0, 0, 0, 0)),
        },
        [lastDate]: {
          end:
            prev[lastDate]?.end || new Date(new Date().setHours(12, 0, 0, 0)),
        },
      };
    });
  }, [firstDate, lastDate]);

  const formatTo12Hour = (timeStr) => {
    let timeFormat = getUserTimeFormat();
    if (timeFormat === "12hr") {
      if (!timeStr) return "";
      const [hours, minutes, seconds] = timeStr.split(":");
      const h = parseInt(hours, 10);
      const suffix = h >= 12 ? "PM" : "AM";
      const hour12 = ((h + 11) % 12) + 1; // converts 0–23 → 1–12
      return `${hour12}:${minutes}:${seconds} ${suffix}`;
    } else {
      return timeStr;
    }
  };

  const formatToDDMMYY = (dateStr) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    if (!dateStr) return "";
    let getFormat = getUserDateFormat();
    const ExtractDate = dateStr.split("/");
    let [year, month, day] = ExtractDate;
    if (getFormat === "DD/MM/YYYY") {
      return `${day}/${month}/${year}`;
    } else if (getFormat === "MM/DD/YYYY") {
      return `${month}/${day}/${year}`;
    } else if (getFormat === "YYYY/MM/DD") {
      return `${year}/${month}/${day}`;
    } else if (getFormat === "DD MMM YYYY") {
      return `${day} ${months[month - 1]} ${year}`;
    }
  };

  useEffect(() => {
    setErrorMessage((prev) => ({
      ...prev,
      vehicleSelected: "No vehicles assigned to this site yet",
    }));
  }, []);
  const is12HourFormat = getUserTimeFormat() === "12hr" ? true : false;

  const disabledSubmit = () => {
    const isBoolean =
      selectedTab === 1
        ? reportData?.length > 0
          ? false
          : true
        : locationLoader;
    // console.log(isBoolean);
    // return isBoolean;
    return isBoolean;
  };
  const orgName = JSON.parse(localStorage.getItem("userState"))?.organization
    ?.name;

  return (
    <>
      {/* <TitleBar />
      <NavMenu />
      <SubTitle
        title="Trip Replays"
        path={`${orgName || "organization"} > Reports > Trip Replays`}
      /> */}

      <Box
      // sx={{ p: 3 }}
      >
        {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            mb: 2,
          }}
        >
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon fontSize="large" />
          </IconButton>
          <Typography variant="h4" sx={{ lineHeight: 1 }}>
            Vehicle Replay System
          </Typography>
        </Box> */}

        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            md={leftOpen ? 5 : 0}
            sx={{
              display: leftOpen ? "block" : "none",
              transition: "all 0.3s ease",
            }}
          >
            <Box ref={leftRef} sx={{ p: 2, minHeight: leftHeight }}>
              <Box
                sx={{
                  height: "43px",
                  borderRadius: "12px",
                  padding: "10px 20px",
                  backgroundColor: "#647490",
                  boxShadow: "-2px 2px 5px 0px #00000040",
                  color: "#fff",
                  fontFamily: "Roboto",
                  fontWeight: 500,
                  fontStyle: "Medium",
                  fontSize: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography>Replay Control</Typography>
                <IconButton onClick={() => setLeftOpen(false)}>
                  <ChevronLeft sx={{ color: "white" }} />
                </IconButton>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                  mt: "24px",
                }}
              >
                {/* <Typography variant="h6">Filters</Typography> */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <FormControl size="small" sx={{ width: "100%" }} fullWidth>
                    <Typography sx={{ mb: 1 }}>Site</Typography>
                    <Select
                      labelId="site-select-label"
                      value={selectedSite}
                      label="Select Site"
                      displayEmpty
                      onChange={(e) => handleSelectSites(e)}
                      IconComponent={NormalArrowFunction}
                      sx={{
                        width: "100%",
                        border: "2px solid #95A0B3",
                        borderRadius: "16px",
                        height: "43px",
                        paddingTop: "12px",
                        paddingRight: "24px",
                        paddingBottom: "12px",
                        paddingLeft: "24px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                    >
                      {sitesList?.length > 0 ? (
                        sitesList?.map((s) => (
                          <MenuItem key={s?.id} value={s?.id}>
                            {s?.name}
                          </MenuItem>
                        ))
                      ) : sitesLoading ? (
                        <MenuItem disabled>
                          <CircularProgress size={20} sx={{ mr: 1 }} />
                          Loading Sites...
                        </MenuItem>
                      ) : (
                        <MenuItem value="">No Sites Available</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Box>
              </Box>

              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                textColor="primary"
                indicatorColor="primary"
                variant="fullWidth" // Makes tabs take equal space
                sx={{
                  mb: 2,
                  background: "#E8EAEE",
                  borderRadius: "8px",
                  padding: "4px",
                  height: "43px",
                  minHeight: "43px",
                  "& .MuiTabs-indicator": {
                    display: "none", // Removes the bottom border/indicator
                  },
                }}
              >
                <Tab
                  label="Vehicles Replay"
                  sx={{
                    textTransform: "capitalize",
                    borderRadius: "4px",
                    padding: "8px 4px",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "16px",
                    minHeight: "35px",
                    "&.Mui-selected": {
                      backgroundColor: "#20A8E0",
                      color: "#FFFFFF",
                    },
                    "&:not(.Mui-selected)": {
                      color: "#666666", // Color for unselected tabs
                    },
                  }}
                />
                <Tab
                  label="Trips Replay"
                  sx={{
                    textTransform: "capitalize",
                    borderRadius: "4px",
                    padding: "8px 4px",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "16px",
                    minHeight: "35px",
                    "&.Mui-selected": {
                      backgroundColor: "#20A8E0",
                      color: "#FFFFFF",
                    },
                    "&:not(.Mui-selected)": {
                      color: "#666666",
                    },
                  }}
                />
                <Tab
                  label="Routes Replay"
                  sx={{
                    textTransform: "capitalize",
                    borderRadius: "4px",
                    padding: "8px 4px",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "16px",
                    minHeight: "35px",
                    "&.Mui-selected": {
                      backgroundColor: "#20A8E0",
                      color: "#FFFFFF",
                    },
                    "&:not(.Mui-selected)": {
                      color: "#666666",
                    },
                  }}
                />
              </Tabs>
              <Box>
                {/* Date Range Selection */}
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <Typography sx={{ mb: 1 }}>Duration</Typography>
                  <Select
                    labelId="date-range-label"
                    value={selectedDateRange}
                    onChange={handleDateRangeChange}
                    label="Duration"
                    IconComponent={NormalArrowFunction}
                    sx={{
                      width: "100%",
                      border: "2px solid #95A0B3",
                      borderRadius: "16px",
                      height: "43px",
                      paddingTop: "12px",
                      paddingRight: "24px",
                      paddingBottom: "12px",
                      paddingLeft: "24px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    }}
                  >
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="yesterday">Yesterday</MenuItem>
                    <MenuItem value="last 7 days">Last 7 Days</MenuItem>
                    <MenuItem value="last 30 days">Last 30 Days</MenuItem>
                    <MenuItem value="custom">Custom</MenuItem>
                  </Select>
                </FormControl>

                {/* For all ranges → Global Time Input */}
                {selectedDateRange &&
                  selectedDateRange !== "last 7 days" &&
                  selectedDateRange !== "last 30 days" &&
                  selectedDateRange !== "custom" &&
                  selectedTab !== 1 && (
                    <>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Grid container spacing={2} sx={{ mb: 2 }}>
                          {/* START TIME */}
                          <Grid item xs={6}>
                            <Typography sx={{ mb: 1 }}>Start Time</Typography>
                            <TimePicker
                              value={timeRange.start}
                              timeSteps={{ minutes: 1 }}
                              slots={{
                                openPickerIcon: () => (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.16667 1.33301C4.49067 1.33301 1.5 4.32367 1.5 7.99967C1.5 11.6757 4.49067 14.6663 8.16667 14.6663C11.8427 14.6663 14.8333 11.6757 14.8333 7.99967C14.8333 4.32367 11.8427 1.33301 8.16667 1.33301ZM12 8.66634H7.5V3.99967H8.83333V7.33301H12V8.66634Z"
                                      fill="#183059"
                                    />
                                  </svg>
                                ),
                              }}
                              sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  border: "2px solid #95A0B3",
                                  borderRadius: "16px",
                                  height: "43px",
                                  paddingLeft: "24px",
                                  paddingRight: "24px",
                                },
                                "& .MuiOutlinedInput-input": {
                                  padding: "12px 0",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    border: "none",
                                  },
                                // Disable pointer events on the icon button
                                "& .MuiInputAdornment-root button": {
                                  pointerEvents: "none",
                                },
                              }}
                              onChange={(newValue) => {
                                setTimeRange({
                                  ...timeRange,
                                  start: newValue,
                                });
                              }}
                              onAccept={() => {
                                let startTime =
                                  String(timeRange?.start)?.split(" ")[4] ||
                                  "00:00:00";

                                handleCallLocationData("startTime", {
                                  sTime: startTime,
                                  eTime: null,
                                  sDate: null,
                                  eDate: null,
                                  dRange: null,
                                  newDate: null,
                                });
                              }}
                              ampm={is12HourFormat}
                              slotProps={{
                                textField: { fullWidth: true, error: false },
                              }}
                            />
                          </Grid>

                          {/* END TIME */}
                          <Grid item xs={6}>
                            <Typography sx={{ mb: 1 }}>End Time</Typography>
                            <TimePicker
                              // label="End Time"
                              value={timeRange.end}
                              timeSteps={{ minutes: 1 }}
                              sx={{
                                openPickerIcon: { sx: { display: "none" } },
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  border: "2px solid #95A0B3",
                                  borderRadius: "16px",
                                  height: "43px",
                                  paddingLeft: "24px",
                                  paddingRight: "24px",
                                },
                                "& .MuiOutlinedInput-input": {
                                  padding: "12px 0", // Controls the vertical padding of the input text
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    border: "none",
                                  },
                                "& .MuiInputAdornment-root button": {
                                  pointerEvents: "none",
                                },
                              }}
                              slots={{
                                openPickerIcon: () => (
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.16667 1.33301C4.49067 1.33301 1.5 4.32367 1.5 7.99967C1.5 11.6757 4.49067 14.6663 8.16667 14.6663C11.8427 14.6663 14.8333 11.6757 14.8333 7.99967C14.8333 4.32367 11.8427 1.33301 8.16667 1.33301ZM12 8.66634H7.5V3.99967H8.83333V7.33301H12V8.66634Z"
                                      fill="#183059"
                                    />
                                  </svg>
                                ),
                              }}
                              onChange={(newValue) => {
                                const start =
                                  timeRange.start ||
                                  new Date().setHours(0, 0, 0, 0);

                                if (newValue >= start) {
                                  setTimeRange((prev) => ({
                                    ...prev,
                                    end: newValue,
                                  }));
                                  setErrorMessage((prev) => ({
                                    ...prev,
                                    endTime: null,
                                  }));
                                } else {
                                  setErrorMessage((prev) => ({
                                    ...prev,
                                    endTime:
                                      "End time cannot be before start time!",
                                  }));
                                }
                              }}
                              onAccept={() => {
                                let endTime =
                                  String(timeRange?.end)?.split(" ")[4] ||
                                  "12:00:00";

                                handleCallLocationData("endTime", {
                                  sTime: null,
                                  eTime: endTime,
                                  sDate: null,
                                  eDate: null,
                                  dRange: null,
                                  newDate: null,
                                });
                              }}
                              ampm={is12HourFormat} // ✅ dynamically switch format
                              slotProps={{
                                textField: { fullWidth: true, error: false },
                              }}
                            />
                            {errorMessage?.endTime && (
                              <Typography
                                variant="body2"
                                color="error"
                                sx={{ mb: 1 }}
                              >
                                {errorMessage.endTime}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      </LocalizationProvider>
                    </>
                  )}

                {selectedDateRange === "custom" && (
                  <Box sx={{ mb: 2 }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Grid container spacing={2}>
                        {/* START DATE */}
                        <Grid item xs={6}>
                          <Typography sx={{ mb: 1 }}>Start Date</Typography>
                          <DatePicker
                            value={startDate ? new Date(startDate) : null}
                            onChange={(newValue) => {
                              if (!newValue) return;
                              const formattedDate = newValue
                                .toISOString()
                                .split("T")[0];
                              handleStartDateChange({
                                target: { value: formattedDate },
                              });
                            }}
                            maxDate={new Date()}
                            format={convertToDateFnsFormat(dateFormat)}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: !!errorMessage.startDate,
                                helperText: errorMessage.startDate,
                                placeholder: dateFormat,
                                sx: {
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "16px",

                                    paddingLeft: "24px",
                                    height: "43px",
                                    "& fieldset": {
                                      borderColor: "#95A0B3",
                                      borderWidth: "2px",
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "#95A0B3",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "#95A0B3",
                                    },
                                    "& input": {
                                      fontFamily: "Roboto",
                                      fontWeight: 400,
                                      fontSize: "16px",
                                      color: "#111214",
                                      padding: "12px 0",
                                    },
                                  },
                                },
                              },
                            }}
                            slots={{
                              openPickerIcon: () => (
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14 13.333V3.99967C14 3.26434 13.402 2.66634 12.6667 2.66634H11.3333V1.33301H10V2.66634H6V1.33301H4.66667V2.66634H3.33333C2.598 2.66634 2 3.26434 2 3.99967V13.333C2 14.0683 2.598 14.6663 3.33333 14.6663H12.6667C13.402 14.6663 14 14.0683 14 13.333ZM6 11.9997H4.66667V10.6663H6V11.9997ZM6 9.33301H4.66667V7.99967H6V9.33301ZM8.66667 11.9997H7.33333V10.6663H8.66667V11.9997ZM8.66667 9.33301H7.33333V7.99967H8.66667V9.33301ZM11.3333 11.9997H10V10.6663H11.3333V11.9997ZM11.3333 9.33301H10V7.99967H11.3333V9.33301ZM12.6667 5.99967H3.33333V4.66634H12.6667V5.99967Z"
                                    fill="#183059"
                                  />
                                </svg>
                              ),
                            }}
                          />
                        </Grid>

                        {/* END DATE */}
                        <Grid item xs={6}>
                          <Typography sx={{ mb: 1 }}>End Date</Typography>
                          <DatePicker
                            value={endDate ? new Date(endDate) : null}
                            onChange={(newValue) => {
                              if (!newValue) return;
                              const formattedDate = newValue
                                .toISOString()
                                .split("T")[0];
                              handleEndDateChange({
                                target: { value: formattedDate },
                              });
                            }}
                            minDate={
                              startDate ? new Date(startDate) : undefined
                            }
                            maxDate={new Date()}
                            format={convertToDateFnsFormat(dateFormat)}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: !!errorMessage.endDate,
                                helperText: errorMessage.endDate,
                                placeholder: dateFormat,
                                sx: {
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "16px",
                                    paddingLeft: "24px",
                                    fontSize: "16px",
                                    height: "43px",
                                    "& fieldset": {
                                      borderColor: "#95A0B3",
                                      borderWidth: "2px",
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "#95A0B3",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "#95A0B3",
                                    },
                                    "& input": {
                                      fontFamily: "Roboto",
                                      fontWeight: 400,
                                      fontSize: "16px",
                                      color: "#111214",
                                      padding: "12px 0",
                                    },
                                  },
                                },
                              },
                            }}
                            slots={{
                              openPickerIcon: () => (
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14 13.333V3.99967C14 3.26434 13.402 2.66634 12.6667 2.66634H11.3333V1.33301H10V2.66634H6V1.33301H4.66667V2.66634H3.33333C2.598 2.66634 2 3.26434 2 3.99967V13.333C2 14.0683 2.598 14.6663 3.33333 14.6663H12.6667C13.402 14.6663 14 14.0683 14 13.333ZM6 11.9997H4.66667V10.6663H6V11.9997ZM6 9.33301H4.66667V7.99967H6V9.33301ZM8.66667 11.9997H7.33333V10.6663H8.66667V11.9997ZM8.66667 9.33301H7.33333V7.99967H8.66667V9.33301ZM11.3333 11.9997H10V10.6663H11.3333V11.9997ZM11.3333 9.33301H10V7.99967H11.3333V9.33301ZM12.6667 5.99967H3.33333V4.66634H12.6667V5.99967Z"
                                    fill="#183059"
                                  />
                                </svg>
                              ),
                            }}
                          />
                        </Grid>
                      </Grid>
                    </LocalizationProvider>
                    {Object.keys(customDateTimes).length > 0 &&
                      selectedTab !== 1 && (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <Box sx={{ mt: 2 }}>
                            <Grid
                              container
                              spacing={1}
                              alignItems="center"
                              sx={{ mb: 3 }}
                            >
                              <Grid item xs={6}>
                                <Typography sx={{ mb: 1 }}>
                                  {" "}
                                  Start Time
                                </Typography>
                                <TimePicker
                                  // label="Start Time"
                                  value={customDateTimes[firstDate].start}
                                  sx={{
                                    openPickerIcon: { sx: { display: "none" } },
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                      border: "2px solid #95A0B3",
                                      borderRadius: "16px",
                                      height: "43px",
                                      paddingLeft: "24px",
                                      paddingRight: "24px",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      padding: "12px 0", // Controls the vertical padding of the input text
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: "none",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                      {
                                        border: "none",
                                      },
                                    "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                      {
                                        border: "none",
                                      },
                                  }}
                                  onChange={(newValue) =>
                                    handleCustomTimeChange(
                                      firstDate,
                                      "start",
                                      newValue
                                    )
                                  }
                                  slots={{
                                    openPickerIcon: () => (
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.16667 1.33301C4.49067 1.33301 1.5 4.32367 1.5 7.99967C1.5 11.6757 4.49067 14.6663 8.16667 14.6663C11.8427 14.6663 14.8333 11.6757 14.8333 7.99967C14.8333 4.32367 11.8427 1.33301 8.16667 1.33301ZM12 8.66634H7.5V3.99967H8.83333V7.33301H12V8.66634Z"
                                          fill="#183059"
                                        />
                                      </svg>
                                    ),
                                  }}
                                  onAccept={() => {
                                    let startTime =
                                      String(
                                        customDateTimes[firstDate].start
                                      )?.split(" ")[4] || "00:00:00";

                                    handleCallLocationData("startTime", {
                                      sTime: startTime,
                                      eTime: null,
                                      sDate: null,
                                      eDate: null,
                                      dRange: null,
                                      newDate: null,
                                    });
                                  }}
                                  ampm={is12HourFormat}
                                  timeSteps={{ minutes: 1 }}
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      error: false,
                                    },
                                  }}
                                />
                              </Grid>

                              <Grid item xs={6}>
                                <Typography sx={{ mb: 1 }}>End Time</Typography>
                                <TimePicker
                                  value={customDateTimes[lastDate].end}
                                  sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                      border: "2px solid #95A0B3",
                                      borderRadius: "16px",
                                      height: "43px",
                                      paddingLeft: "24px",
                                      paddingRight: "24px",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      padding: "12px 0",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: "none",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                      {
                                        border: "none",
                                      },
                                    "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                      {
                                        border: "none",
                                      },
                                    // Disable pointer events on the icon button
                                    "& .MuiInputAdornment-root button": {
                                      pointerEvents: "none",
                                    },
                                  }}
                                  slots={{
                                    openPickerIcon: () => (
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.16667 1.33301C4.49067 1.33301 1.5 4.32367 1.5 7.99967C1.5 11.6757 4.49067 14.6663 8.16667 14.6663C11.8427 14.6663 14.8333 11.6757 14.8333 7.99967C14.8333 4.32367 11.8427 1.33301 8.16667 1.33301ZM12 8.66634H7.5V3.99967H8.83333V7.33301H12V8.66634Z"
                                          fill="#183059"
                                        />
                                      </svg>
                                    ),
                                  }}
                                  onChange={(newValue) =>
                                    handleCustomTimeChange(
                                      lastDate,
                                      "end",
                                      newValue
                                    )
                                  }
                                  onAccept={() => {
                                    let endTime =
                                      String(
                                        customDateTimes[lastDate].end
                                      )?.split(" ")[4] || "12:00:00";

                                    handleCallLocationData("endTime", {
                                      sTime: null,
                                      eTime: endTime,
                                      sDate: null,
                                      eDate: null,
                                      dRange: null,
                                      newDate: null,
                                    });
                                  }}
                                  ampm={is12HourFormat}
                                  timeSteps={{ minutes: 1 }}
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      error: false,
                                    },
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </LocalizationProvider>
                      )}
                  </Box>
                )}
              </Box>

              {selectedTab === 2 && (
                <>
                  {routeList.length > 0 ? (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                      <InputLabel id="route-select-label">
                        Select Routes
                      </InputLabel>
                      <Select
                        labelId="route-select-label"
                        multiple
                        label="Select Routes"
                        value={selectedRoute}
                        onChange={handleRouteChange}
                        renderValue={(selected) => {
                          if (selected.length === routeList.length)
                            return "All Routes Selected";
                          if (selected.length === 0) return "None Selected";
                          return routeList
                            .filter((r) => selected.includes(r.id))
                            .map((r) => r.name)
                            .join(", ");
                        }}
                      >
                        {/* Select All / Deselect All Option */}
                        <MenuItem value="all">
                          {routeList.length > 0 && (
                            <Checkbox
                              checked={
                                routeList.length > 0 &&
                                selectedRoute.length === routeList.length
                              }
                              indeterminate={
                                selectedRoute.length > 0 &&
                                selectedRoute.length < routeList.length
                              }
                            />
                          )}

                          {routeList.length > 0 && (
                            <ListItemText
                              primary={
                                selectedRoute.length === routeList.length
                                  ? "Deselect All"
                                  : "Select All"
                              }
                            />
                          )}
                        </MenuItem>

                        {/* Routes List */}
                        {routeList.length > 0 ? (
                          routeList.map((route) => (
                            <MenuItem key={route.id} value={route.id}>
                              <Checkbox
                                checked={selectedRoute.includes(route.id)}
                              />
                              <ListItemText primary={route.name} />
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled>No Routes Available</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  ) : (
                    <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                      No Routes Available
                    </Typography>
                  )}

                  {(!selectedRoute ||
                    selectedRoute.length === 0 ||
                    routeList.length === 0) &&
                    errorMessage && (
                      <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                        {errorMessage?.routesList}
                      </Typography>
                    )}
                </>
              )}

              {(selectedTab !== 2 ||
                ((selectedTab === 2 || selectedTab === 0) &&
                  location?.length > 0)) &&
                !(selectedTab === 2 && routeList?.length === 0) && ( // 👈 added this line
                  <>
                    {vehicleList?.length > 0 ? (
                      <>
                        <FormControl fullWidth sx={{ mb: 1 }}>
                          {/* <InputLabel id="vehicle-select-label">
                            Select Vehicles
                          </InputLabel> */}
                          <Typography>Select Vehicles</Typography>
                          <Select
                            labelId="vehicle-select-label"
                            IconComponent={NormalArrowFunction}
                            sx={{
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                border: "2px solid #95A0B3",
                                borderRadius: "16px",
                                height: "43px",
                                paddingLeft: "24px",
                                paddingRight: "24px",
                              },
                              "& .MuiOutlinedInput-input": {
                                padding: "12px 0", // Controls the vertical padding of the input text
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "2px solid #95A0B3", // Move border here
                                borderRadius: "16px",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                border: "2px solid #95A0B3", // Move border here
                                borderRadius: "16px",
                              },
                              "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: "2px solid #95A0B3", // Move border here
                                  borderRadius: "16px",
                                },
                            }}
                            multiple={selectedTab === 2 || selectedTab === 0}
                            value={
                              selectedTab === 2 || selectedTab === 0
                                ? selectedVehicles
                                : selectedVehicles?.[0] || ""
                            }
                            // label="Select Vehicles"
                            disabled={selectedTab === 2 && !routeData}
                            onChange={handleVehicleChange}
                            renderValue={(selected) =>
                              selectedTab === 2 || selectedTab === 0 ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 0.5,
                                    ml: 3,
                                  }}
                                >
                                  {selected?.map((vehicleId) => {
                                    const vehicle = uniqueVehicleList.find(
                                      (vehicleItem) =>
                                        getVehicleDeviceId(vehicleItem) ===
                                        vehicleId
                                    );
                                    return (
                                      <Chip
                                        key={vehicleId}
                                        label={vehicle?.name || "Unknown"}
                                        size="small"
                                        sx={{
                                          backgroundColor: "#C8CBD0",
                                          height: "23px",
                                          borderRadius: "4px",
                                          padding: "2px 8px",
                                        }}
                                      />
                                    );
                                  })}
                                </Box>
                              ) : (
                                uniqueVehicleList.find(
                                  (vehicleItem) =>
                                    getVehicleDeviceId(vehicleItem) === selected
                                )?.name || ""
                              )
                            }
                          >
                            {(selectedTab === 2 || selectedTab === 0) && (
                              <MenuItem value="select-all">
                                <Checkbox
                                  checked={
                                    selectedVehicles.length ===
                                      uniqueVehicleList.length &&
                                    uniqueVehicleList.length > 0
                                  }
                                  indeterminate={
                                    selectedVehicles.length > 0 &&
                                    selectedVehicles.length <
                                      uniqueVehicleList.length
                                  }
                                />
                                <ListItemText primary="Select All" />
                              </MenuItem>
                            )}

                            {uniqueVehicleList.map((vehicle) => (
                              <MenuItem
                                key={getVehicleDeviceId(vehicle)}
                                value={getVehicleDeviceId(vehicle)}
                              >
                                {selectedTab === 2 || selectedTab === 0 ? (
                                  <>
                                    <Checkbox
                                      checked={
                                        selectedVehicles.indexOf(
                                          getVehicleDeviceId(vehicle)
                                        ) > -1
                                      }
                                    />
                                    <ListItemText primary={vehicle.name} />
                                  </>
                                ) : (
                                  vehicle.name
                                )}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </>
                    ) : (
                      // 🚨 Show this when no vehicles are available
                      selectedTab === 0 && (
                        <Typography
                          variant="body2"
                          color="error"
                          sx={{ mb: 1 }}
                        >
                          No Vehicle available for this site
                        </Typography>
                      )
                    )}
                  </>
                )}

              {/* {selectedTab === 1 && (
              <>
                {
                  (vehicleList?.length > 0 && selectedVehicles?.length >0) ?
                    <FormControl
                    fullWidth
                    sx={{ mb: 2 }}
                    disabled={selectedVehicles?.length === 0}
                  >
                    <InputLabel id="trip-select-label">Select Trip</InputLabel>
                    <Select
                      labelId="trip-select-label"
                      value={selectedTrip}
                      label="Select Trip"
                      onChange={handleTripChange}
                    >
                      {reportData?.length > 0 && !loadingTrip ? (
                        reportData.map((trip, index) => {
                          return (
                            <MenuItem key={trip?.id} value={trip?.id}>
                              {selectedDateRange !== "today" &&
                                selectedDateRange !== "yesterday" &&
                                `${formatToDDMMYY(trip.date)} - `}
                              {formatTo12Hour(trip.startTime)} to{" "}
                              {formatTo12Hour(trip.endTime)}
                            </MenuItem>
                          );
                        })
                      ) : loadingTrip ? (
                        <MenuItem disabled>
                          <CircularProgress size={20} sx={{ mr: 1 }} />
                          Loading trips...
                        </MenuItem>
                      ) : (
                        <MenuItem value="">No trips available</MenuItem>
                      )}
                    </Select>
                  </FormControl>
              :
                  <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                    No Trips Available
                  </Typography>
                }
                
               

                {(!selectedTrip || reportData.length === 0) && alertMessage && (
                  <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                    {alertMessage}
                  </Typography>
                )}
              </>
            )} */}

              {selectedTab === 1 && (
                <>
                  {vehicleList?.length > 0 ? (
                    selectedVehicles?.length > 0 ? (
                      reportData?.length > 0 && !loadingTrip ? (
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <InputLabel id="trip-select-label">
                            Select Trip
                          </InputLabel>
                          <Select
                            labelId="trip-select-label"
                            value={selectedTrip}
                            label="Select Trip"
                            onChange={handleTripChange}
                          >
                            {reportData.map((trip) => (
                              <MenuItem key={trip?.id} value={trip?.id}>
                                {selectedDateRange !== "today" &&
                                  selectedDateRange !== "yesterday" &&
                                  `${formatToDDMMYY(trip.date)} - `}
                                {formatTo12Hour(trip.startTime)} to{" "}
                                {formatTo12Hour(trip.endTime)}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      ) : loadingTrip ? (
                        <Box
                          sx={{ display: "flex", alignItems: "center", mb: 1 }}
                        >
                          <CircularProgress size={20} sx={{ mr: 1 }} />
                          <Typography variant="body2">
                            Loading trips...
                          </Typography>
                        </Box>
                      ) : (
                        // Only show this when vehicles are selected but trips are empty
                        <Typography
                          variant="body2"
                          color="error"
                          sx={{ mb: 1 }}
                        >
                          {"No trips Available"}
                        </Typography>
                      )
                    ) : null // nothing shown when no vehicle is selected
                  ) : (
                    <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                      {!vehicleList.length && "No Trips Available"}
                    </Typography>
                  )}

                  {errorMessage?.tripList && selectedTab === 1 && (
                    <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                      {errorMessage?.tripList}
                    </Typography>
                  )}
                </>
              )}

              {selectedTrip &&
                selectedTab === 1 &&
                reportData.length > 0 &&
                vehicleList?.length > 0 && (
                  <Card variant="outlined" sx={{ mb: 2 }}>
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        Trip Details
                      </Typography>
                      {selectedTrip && (
                        <>
                          <Typography>
                            Vehicle:{" "}
                            {findTripDetails(selectedTrip)?.vehicleName}
                          </Typography>
                          <Typography>
                            Date:{" "}
                            {formatToDDMMYY(
                              findTripDetails(selectedTrip)?.date
                            )}
                          </Typography>
                          <Typography>
                            Start Time:{" "}
                            {formatTo12Hour(
                              findTripDetails(selectedTrip)?.startTime
                            )}
                          </Typography>

                          <Typography>
                            End Time:{" "}
                            {formatTo12Hour(
                              findTripDetails(selectedTrip)?.endTime
                            )}
                          </Typography>

                          <Typography>
                            Duration: {findTripDetails(selectedTrip)?.duration}
                          </Typography>
                        </>
                      )}
                    </CardContent>
                  </Card>
                )}

              <Button
                disabled={disabledSubmit() || locationLoader}
                sx={{
                  width: "100%",
                  height: "55px",
                  mt: "24px",
                  borderRadius: "8px",
                  padding: "16px 24px",
                  backgroundColor: "#F9E719",
                  textTransform: "none",
                  border: "1px solid #414958",
                  fontFamily: "Roboto",
                  fontWeight: 600,
                  fontStyle: "semibold",
                  fontSize: "20px",
                  color: "#111214",
                  "&:hover": {
                    backgroundColor: "yellow",
                  },
                  marginBottom: selectedTab !== 1 ? "10px" : "60px",
                }}
                type="button"
                onClick={handleSubmit}
              >
                {locationLoader ? (
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
                  >
                    <CircularProgress size={20} sx={{ color: "#000" }} />
                    <Typography
                      component="span"
                      sx={{ fontSize: "16px", fontWeight: 600, color: "#111214" }}
                    >
                      Loading Replay...
                    </Typography>
                  </Box>
                ) : (
                  "Load Replay"
                )}
              </Button>
            </Box>
          </Grid>

          {/* Map Section */}
          <Grid
            item
            xs={12}
            md={leftOpen ? 7 : 12}
            sx={{
              transition: "all 0.3s ease",
            }}
          >
            <Box ref={rightRef} sx={{ p: 2, minHeight: leftHeight }}>
              <Box
                sx={{
                  height: "43px",
                  borderRadius: "12px",
                  padding: "10px 20px",
                  backgroundColor: "#647490",
                  boxShadow: "-2px 2px 5px 0px #00000040",
                  color: "#fff",
                  fontFamily: "Roboto",
                  fontWeight: 500,
                  fontStyle: "Medium",
                  fontSize: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography>Vehicle Path Visualization</Typography>
                {!leftOpen && (
                  <IconButton
                    onClick={() => setLeftOpen(true)}
                    sx={
                      {
                        // backgroundColor: "white",
                        // boxShadow: 2,
                      }
                    }
                  >
                    <ChevronRight sx={{ color: "white" }} />
                  </IconButton>
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: leftOpen ? "space-between" : "flex-end",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                {/* <Typography variant="h6">
                  {leftOpen ? "Vehicle Path" : ""}
                </Typography> */}
              </Box>

              {!location.length ? (
                <Box
                  sx={{ height: "500px", width: "100%" }}
                  style={{
                    border: "1px solid #183059",
                    width: "100%",
                    borderRadius: "16px",
                  }}
                >
                  <iframe
                    title="Google Map - Silk Board Bengaluru"
                    width="100%"
                    height="100%"
                    style={{ border: 0, borderRadius: "16px" }}
                    loading="lazy"
                    allowFullScreen
                    src={`https://www.google.com/maps/embed/v1/view?key=${config.googleMapsApiKey}&center=12.9177,77.6233&zoom=16`}
                  ></iframe>
                </Box>
              ) : (
                <ReplayMap
                  vehicles={vehicleList?.filter((vehicle) => {
                    const v = selectedVehicles?.find(
                      (selectedVehicleId) =>
                        selectedVehicleId === getVehicleDeviceId(vehicle)
                    );
                    if (v) {
                      return vehicle;
                    } else {
                      return false;
                    }
                  })}
                  locationHistory={location}
                  routes={
                    selectedTab === 0 || selectedTab === 2
                      ? routeData
                      : [routeData]
                  }
                  stops={
                    selectedTab === 0 || selectedTab === 2
                      ? routeData?.flatMap((route) => route?.stops || [])
                      : routeData?.stops
                  }
                  selectedTab={selectedTab}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
      {/* <Footer/> */}
    </>
  );
};

export default ReplayVehicle;
